import { render } from "./AdminVerification.vue?vue&type=template&id=39daaf7c&scoped=true"
import script from "./AdminVerification.vue?vue&type=script&lang=js"
export * from "./AdminVerification.vue?vue&type=script&lang=js"

import "./AdminVerification.vue?vue&type=style&index=0&id=39daaf7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39daaf7c"]])

export default __exports__